// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g1_n","textarea":"styles_textarea__pswV8"};